module.exports = __webpack_public_path__ + "static/media/tutorial-07.8eeae0d3.jpg";